// src/theme/moods.js
export const MOODS = {
  sei: { label: "静" },
  wa: { label: "和" },
  dou: { label: "動" },
};

export const DEFAULT_MOOD = "sei";

// ページ側が提案する“おすすめ”
// まずは最小。必要になったら増やせばOK
export function suggestMoodByPath(pathname) {
  if (pathname.startsWith("/quest")) return "dou";
  if (pathname.startsWith("/map")) return "dou";
  if (pathname.startsWith("/community")) return "dou";

  if (pathname.startsWith("/shrines")) return "wa";
  if (pathname.startsWith("/legends")) return "wa";
  if (pathname.startsWith("/guide")) return "wa";

  return "sei"; // 情報閲覧デフォルト
}
